const _ = 601, D = 1100, I = [601, 1100], E = I.map(
  (T) => `@media (min-width: ${T}px)`
);
export {
  I as BREAKPOINTS,
  E as BREAKPOINTS_MEDIA,
  D as DESKTOP_MIN_WIDTH,
  _ as TABLET_MIN_WIDTH
};
